import {inject, Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {NavigationStateService} from '../services/navigation-state.service';
import {UserStateService} from '../states/user-state.service';
import {UserService} from '../services/user.service';
import {catchError, Observable, of, switchMap} from 'rxjs';
import {UserLinksStateService} from '../states/user-links-state.service';
import {UserInterfaces, UserNavigationLinks} from '../interfaces/user.interfaces';

@Injectable({ providedIn: 'root' })
export class HasLinksGuard implements CanActivate {
  private state = inject(UserLinksStateService);
  private userState = inject(UserStateService);
  private router = inject(Router);
  private userService = inject(UserService);

  canActivate(): Observable<boolean> {
      const userLinks = this.state.userLinks();
      const user = this.userState.user();

    if (Object.entries(user).length === 0) {
      return this.userService.getUser().pipe(
        switchMap(fetchedUser => {
          this.userState.user.set(fetchedUser);
          return this.getMenu$(userLinks, this.userState.user());
        }));
    }

    return this.getMenu$(userLinks, user);
  }

  getMenu$(userLinks: {items: UserNavigationLinks[], totalCount: number}, user: UserInterfaces) {
    if (userLinks?.totalCount > 0) {
      return of(true);
    }

    return this.userService.getUserNavigation().pipe(
      switchMap(userLinks => {
        this.state.userLinks.set(userLinks);
        if (!userLinks.totalCount && user.isAdmin) {
          this.router.navigate(['/iframe-pages']);
        }
        return of(userLinks.items.length >= 0);
      }),
      catchError(() => {
        this.router.navigate(['/no-access']);
        return of(false);
      })
    );
  }
}
